// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2q9sV","buttons":"Footer_buttons__6DMgR"};